import React from 'react';
import { Link } from 'react-router-dom';

import { footerLegalLinks } from '../../config/legal';

/**
 * The legal footer of the signed-out pages (KPR-478; KPR-259 adds Privacy and
 * Terms to the same list in src/config/legal.js): one quiet line of links
 * under the sign-in and sign-up forms. Washington's health data law wants the
 * consumer health data policy linked from the homepage — `/` signed out is
 * that page.
 *
 * Renders NOTHING until the legal pages publish: a link to a page that only
 * says "not published yet" would be a promise the footer cannot keep.
 */
export default function LegalLinks() {
	const links = footerLegalLinks();
	if (!links.length) return null;
	return (
		<nav className="legal-links" aria-label="Legal">
			{links.map(page => <Link key={page.key} to={page.path}>{page.label}</Link>)}
		</nav>
	);
}
